<template>
  <wptv-loader
    :show="loading"
    :height="40"
    :width="40"
    class="page-loader" />
</template>

<script>
import { WptvLoader } from '../loader'

export default {
  name: 'WptvPageLoader',
  components: {
    WptvLoader
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    start () {
      this.loading = true
    },
    finish () {
      setTimeout(() => {
        this.loading = false

        // Emit a signal to notify the end of the loading at Vue root level to ease page loading dependant processing.
        // @mha: This has been introduced to help navik to restore focus but it can be used elsewhere
        this.$root.$emit('page-loaded')
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-loader {
    position: fixed;
    z-index: 999;
    bottom: 10px;
    right: 10px;
    width: auto;
  }
</style>
